<template>
  <div class="salesDetail" v-if="flag">
    <BasicContainer>
      <OrderInfo :tableData="tableData"></OrderInfo>
      <ShopInfo
        class="shopInfo"
        :dataList="shopInfoList"
        :shopName="shopName"
      ></ShopInfo>
      <CustomInfo
        class="customInfo"
        :imgList="imgList"
        v-if="imgList.length !== 0"
      ></CustomInfo>
      <SourceInfo :barCode="barCode"></SourceInfo>
      <!-- <FixBtn class="fixBtn"></FixBtn> -->
    </BasicContainer>
  </div>
</template>

<script>
import OrderInfo from "./orderInfo";
import ShopInfo from "./shopInfo";
import CustomInfo from "./customInfo";
import SourceInfo from "./sourceInfo";
// import FixBtn from "./fixBtn";
import { getSaleDetail } from "@/api/sales.js";
export default {
  data() {
    return {
      tableData: {},
      imgList: [],
      shopInfoList: [],
      shopName: "",
      flag: false,
      barCode: "",
    };
  },
  components: {
    OrderInfo,
    ShopInfo,
    CustomInfo,
    SourceInfo,
    // FixBtn,
  },
  created() {
    const sn = this.$route.query.sn;
    this.barCode = this.$route.query.barCode;
    getSaleDetail({ sn }).then((res) => {
      this.tableData = res.data.data;
      this.imgList = res.data.data.files;
      this.shopInfoList = res.data.data.productSnList;
      this.shopName = res.data.data.shopName;
      this.flag = true;
    });
  },
  mounted() {},
  methods: {
    lookPaper() {
      this.$router.push({ path: "/paper" });
    },
  },
};
</script>

<style lang="less" scoped>
.salesDetail {
  background: rgba(237, 237, 237, 1);
  min-height: 100vh;
  padding: 40px;
}
.name {
  height: 45px;
  line-height: 45px;
  color: rgba(51, 51, 51, 1);
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 40px;
}
.shopInfo {
  margin-top: 40px;
}
.customInfo {
  margin: 40px 0;
}
.fixBtn {
  position: fixed;
  right: 30px;
  top: 80vh;
}
@font-face {
  font-family: "iconfont"; /* Project id 3391031 */
  src: url("//at.alicdn.com/t/font_3391031_qk9b058vwbq.woff2?t=1652182434861")
      format("woff2"),
    url("//at.alicdn.com/t/font_3391031_qk9b058vwbq.woff?t=1652182434861")
      format("woff"),
    url("//at.alicdn.com/t/font_3391031_qk9b058vwbq.ttf?t=1652182434861")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 60px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
